module.exports = __webpack_public_path__ + "img/lsj4.753fc91b.png";